module.exports = __webpack_public_path__ + "static/media/uz.eb1e00b8.svg";